var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAnnotationSkipped = function SvgAnnotationSkipped(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 4,
    fill: "currentColor",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1972_16465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    rx: 7,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1972_16465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    rx: 7,
    fill: "currentColor",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 12,
    rx: 6,
    stroke: "currentColor",
    strokeOpacity: 0.3,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7L17 17",
    stroke: "currentColor",
    strokeWidth: 2
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAnnotationSkipped);
export { ForwardRef as ReactComponent };